// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { rem } from '../../tokens/conversions';
import { treeViewColors } from './treeViewColors';
export var TreeView = function(mode) {
    var c = treeViewColors(mode);
    var override = {
        MuiSimpleTreeView: {
            styleOverrides: {
                root: {
                    color: c.text
                }
            }
        },
        MuiTreeItem: {
            styleOverrides: {
                root: {
                    '&.Mui-focused > .MuiTreeItem-content': {
                        outline: "".concat(rem(2), " solid ").concat(c.focus.border),
                        outlineOffset: rem(-2),
                        backgroundColor: 'transparent'
                    }
                },
                content: {
                    borderRadius: rem(4),
                    padding: "".concat(rem(4), " ").concat(rem(8)),
                    color: c.text,
                    '&:hover': {
                        backgroundColor: c.hover.background
                    },
                    '&.Mui-selected': {
                        backgroundColor: c.selected.background,
                        '&:hover': {
                            backgroundColor: c.hoverSelected.background
                        },
                        '&.Mui-focused': {
                            backgroundColor: c.selected.background
                        }
                    },
                    '&.Mui-focused': {
                        backgroundColor: 'transparent'
                    }
                },
                label: {
                    fontSize: rem(14),
                    lineHeight: rem(18),
                    color: c.text
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=TreeView.js.map